module.exports = __webpack_public_path__ + "static/carousel6.2c0a4cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel6.jpg
// module id = 710
// module chunks = 168707334958949